import { createSlice } from "@reduxjs/toolkit";

// Initial state structure for templates
const initialState = {};

const templateValuesSlice = createSlice({
  name: "templateValues",
  initialState: {},
  reducers: {
    setTemplateValues: (state, action) => {
      const { id, argumentsValues, customProperties } = action.payload;

      if (!id) return; // Prevent storing with an empty key

      if (!state[id]) {
        state[id] = {
          arguments: {},
          customProperties: {},
        };
      }

      // Ensure argumentsValues is not undefined before merging
      if (argumentsValues) {
        state[id].arguments = {
          ...state[id].arguments, // Merge old arguments
          ...argumentsValues, // Add new argument
        };
      }

      // Ensure customProperties is not undefined before merging
      if (customProperties) {
        state[id].customProperties = {
          ...state[id].customProperties,
          ...customProperties,
        };
      }
    },

    clearTemplateValues: () => {
      return {};
    },
  },
});

export const { setTemplateValues, clearTemplateValues } =
  templateValuesSlice.actions;

export default templateValuesSlice.reducer;
